import { useEffect } from 'react';
export function useLockBodyScroll(isLocked) {
    useEffect(() => {
        if (isLocked) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
        return () => {
            document.body.classList.remove('overflow-hidden');
        };
    }, [isLocked]);
}
